<template>
  <div class="sp-template">
    <!-- 从保险页面复制 insuraanceorder.vue -->
    <div class="h-title">提成费用</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">

        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">

          <el-row>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model="conditions.orderIdText" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>

            <el-form-item label="测量开始时间" label-width="100px">
              <el-date-picker v-model.lazy="conditions.startDate" type="date" value-format="yyyy-MM-dd"
                placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="测量结束时间" label-width="100px">
              <el-date-picker v-model.lazy="conditions.endDate" type="date" value-format="yyyy-MM-dd"
                placeholder="结束日期"></el-date-picker>
            </el-form-item>

          </el-row>

          <el-row>
            <el-form-item label="客户">
              <el-select v-model="conditions.orgOwner" filterable clearable placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="渠道">
              <el-select v-model="conditions.productId" filterable clearable placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="业务员" v-if="isSalesman==false">
              <el-select v-model.lazy="conditions.salesman" filterable clearable >
                <el-option v-for="(d, i) in salesmans" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="提成金额为零" label-width="100px" >
              <el-checkbox v-model="conditions.zero"></el-checkbox>
            </el-form-item>

          </el-row>

          <el-row>
            <el-form-item>
              <div class="search-form__buttons">
                <el-button type="primary" size="small" @click="searchTask">搜 索</el-button>
              </div>
            </el-form-item>
          </el-row>


        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane label="待审核" name="0"></el-tab-pane>
          <el-tab-pane label="已审核" name="1"></el-tab-pane>
          <el-tab-pane label="已确认" name="2"></el-tab-pane>
          <el-tab-pane label="待支付" name="3"></el-tab-pane>
          <el-tab-pane label="已支付" name="4"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="popCheck(1)" v-if="in_configs(42201)" v-show="conditions.status==0">审核</el-button>
          <el-button size="small" @click="popCheck(2)" v-if="in_configs(42202)" v-show="conditions.status==1">确认</el-button>
          <el-button size="small" @click="popCheck(3)" v-if="in_configs(42203)" v-show="conditions.status==2">申请支付</el-button>
          <el-button size="small" @click="popCheck(4)" v-if="in_configs(42204)" v-show="conditions.status==3">支付</el-button>


          <el-button size="small" v-if="in_configs(42206)" @click="exportAll(0)">导出业务员汇总</el-button>
          <el-button size="small" v-if="in_configs(42207)" @click="exportAll(1)">导出业务员客户汇总</el-button>
          <el-button size="small" @click="exportAll(2)">导出所有</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border  show-summary style="width: 100%"  :summary-method="getSummaries"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>

        <!-- <el-table-column prop="id" label="id"></el-table-column> -->
        <el-table-column prop="orderId" label="订单号"></el-table-column>

        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>

        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.productId]}}
          </template>
        </el-table-column>
        <el-table-column prop="billedWeight" label="计费重"></el-table-column>
        <el-table-column prop="postcode" label="邮编"></el-table-column>
        <el-table-column prop="amount" label="应收金额"></el-table-column>
        <el-table-column prop="cost" label="预估成本"></el-table-column>
        <el-table-column prop="commissionAmount" label="提成金额"></el-table-column>
        <el-table-column prop="trace" label="提成计算公式"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="measureTime" label="测量时间"></el-table-column>

        <el-table-column label="业务员">
          <template slot-scope="scope">
            {{salesmansMaps[scope.row.salesman]}}
          </template>
        </el-table-column>

        <el-table-column prop="auditedBy" label="审核人" v-if="conditions.status > 0" ></el-table-column>
        <el-table-column prop="auditedAt" label="审核时间" v-if="conditions.status > 0" ></el-table-column>
        <el-table-column prop="confirmedBy" label="确认人" v-if="conditions.status > 1"></el-table-column>
        <el-table-column prop="confirmedAt" label="确认时间" v-if="conditions.status > 1"></el-table-column>
        <el-table-column prop="unpaidBy" label="申请支付人" v-if="conditions.status > 2"></el-table-column>
        <el-table-column prop="unpaidAt" label="申请支付时间" v-if="conditions.status > 2"></el-table-column>
        <el-table-column prop="paidBy" label="支付人" v-if="conditions.status > 3"></el-table-column>
        <el-table-column prop="paidAt" label="支付时间" v-if="conditions.status > 3"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>

        <el-table-column label="操作" v-if="conditions.status==0 || conditions.status==1 || conditions.status==2 ">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="popEdit(scope.row)"  v-if="in_configs(42205)" > 编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 50, 100, 500, 2000, 10000]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 审核弹框 -->
    <!-- <el-dialog title="审核" class="common-select__dialog" :visible.sync="dialogCheckVisible" width="30%">

      <el-form size="small" label-width="100px">
          <el-form-item label="是否通过">
						<el-select v-model="isPass" >
              <el-option key="1" label="通过" value="1"></el-option>
              <el-option key="-1" label="不通过" value="-1"></el-option>
            </el-select>
					</el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="checkSubmit()">确 定</el-button>
      </div>
    </el-dialog> -->



    <el-dialog title="编辑" :visible.sync="dialogEditVisible" width="400px">
      <el-form size="small" label-width="100px">

        <el-form-item label="应收金额">
          <el-input v-model.lazy="editData.amount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="预估成本">
          <el-input v-model.lazy="editData.cost" type="number"></el-input>
        </el-form-item>
        <el-form-item label="提成金额">
          <el-input v-model.lazy="editData.commissionAmount" type="number"></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model.lazy="editData.remarks"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogEditVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSubmit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>




</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
  import { mapState, mapMutations } from "vuex";
  export default {
    data() {
      return {
        totalCommission: 0,
        isSalesman: false,
        customers: [],
        customerMaps: {},
        channels: [],
        channelsMaps: {},
        salesmans: [],
        salesmansMaps: {},

        categorys: [],
        categoryMap: {},
        kinds: [],
        sumbitForm: {
          categoryId: "",
          kindId: "",
          supplierId: ""
        },
        suppliers: [],
        supplierMap: {},
        isPass: "1",
        dialogCheckVisible: false,
        tableData: [],
        batchOrderIds: [],
        multipleSelection: [],
        batchInsuranceOrderIdsShow: false,
        conditions: {
          orderIdText: '',
          startDate: "",
          endDate: "",
          salesman: "",
          orgOwner: "",
          productId: "",
          zero: false, //提成金额为零筛选
          status: 0
        },

        dialogEditVisible: false,
        editData: {},
        total: 0,
        currentPage: 1,
        pageSize: 10
      };
    },
    components: {},
    created() {
      setTimeout(() => {

        let _this = this;
        let urlArray = [
          this.findAllCustomerName(),
          this.findAllChannle()
        ]; // unknown # of urls (1 or more)

        this.$axios.all(urlArray).then(
          this.$axios.spread(function (customerData, channelData) {
            _this.initCustomerData(customerData);
            _this.initChannelData(channelData);

            _this.loadRoleList("业务员");

            _this.query();
          })
        );



      }, 1000);
    },
    methods: {
      ...mapMutations([
        "setManualTrackingNumbers",
        "setOrderListTable",
        "setOrderListConditions",
        "setOrderListSearchMore"
      ]),
      formatRefNumber(refNumber) {
        let arr = refNumber;
        arr.forEach((item, index) => {
          if (item === " " || item === ",") {
            arr.splice(index, 1);
          }
        });
        return arr;
      },
      //查询渠道
      findAllChannle() {
        return this.$request1.get(
          '/system/channel/all',
          {
            withCredentials: true
          }
        );
      },
      //查询客户
      findAllCustomerName() {
        return this.$request1.get(
          '/customerAll',
          {
            withCredentials: true
          }
        );
      },
      initChannelData(data) {
        let _this = this;
        _this.channels = data.data;
        if (_this.channels.length > 0) {
          _this.channels.forEach(c => {
            _this.channelsMaps[c.id] = c.name;
          });
        }
      },
      initCustomerData(data) {
        let _this = this;
        if (data.data.success) {
          _this.customers = data.data.data;
          if (_this.customers.length > 0) {
            _this.customers.forEach(c => {
              _this.customerMaps[c.id] = c.name;
            });
          }
        }
      },
      //查询业务员和客服
      loadRoleList(role) {
        let _this = this;
        _this.$request1
          .get(
            '/staffrole',
            {
              params: {
                role: role
              }
            },
            {
              withCredentials: true
            }
          )
          .then(function (res) {
            if (res.data.success) {
              if (role == "业务员") {
                _this.salesmans = res.data.data;

                _this.salesmans.forEach(a => {
                  _this.salesmansMaps[a.id] = a.name
                })

              } else if (role == "客服") {
                _this.customerServiceStaffs = res.data.data;
              }
            } else {
              _this.salesmans = [];
              _this.customerServiceStaffs = [];
              _this.$message.error(res.data.message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      searchTask() {
        this.currentPage = 1;
        this.query();
      },
      query() {
        let _this = this;

        this.conditions.orderIds = [];

        if (this.conditions.orderIdText) {
          this.conditions.orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
        }

        this.conditions.currentPage = this.currentPage;
        this.conditions.pageSize = this.pageSize;

        //  this.tableData = [{"batchId": "11111", "orderId": "222222222"}]
        //  return;

        this.$request1({
          method: 'post',
          url: '/commission/query',
          data: _this.conditions,
          withCredentials: true,
          header: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            if (response.data.success) {
              this.tableData = response.data.data.list;
              this.total = response.data.total;
              this.isSalesman = response.data.data.salesman;
              this.totalCommission = response.data.data.totalCommission;
              
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      // 表尾行合计
    getSummaries(param) {

      let m = {
        0: 14,
        1: 16,
        2: 18,
        3: 19,
        4: 21
      }
      const { columns, data } = param;
      const sums = [];

      console.log(">>>this.conditions.status==", this.conditions.status)
      let c = m[this.conditions.status];
      for(let i = 0; i < c; i++ ){
        sums.push("")
      }

      sums[sums.length-2] = "提成合计：";
      sums[sums.length-1] = this.totalCommission + "元";

      return sums;
    },
      // 审核弹框
      popCheck(val) {
        let _this = this
        let t = '审核'
        if (val == 2) {
          t = '确认'
        } else if (val == 3) {
          t = '申请支付'
        } else if (val == 4) {
          t = '支付'
        }
        // console.log(this.multipleSelection.length);
        if (this.multipleSelection.length == 0) {
          this.$message.error(`请勾选要${t}的订单`);
          return;
        }
        this.$confirm(`确定要${t}该订单`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {

          let ids = this.multipleSelection.map(a => a.id)
          let editForm = {
            ids: ids,
            status: val
          }

          this.$request1.post(
              '/commission/edit',
              editForm,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json"
                }
              }
            ).then(function (response) {
              if (response.data.success) {
                _this.$message.success("提交成功");
                _this.dialogEditVisible = false
                _this.query();

              } else {
                _this.$message.error(response.data.message);
              }
            });


        })
          .catch(() => { });

      },
      // 审核提交
      checkSubmit() {
        let _this = this;
        let ids = this.multipleSelection.map(a => a.id);

        // console.log(ids);
        // return;
        this.$request1
          .post(
            '/insurance/audit',
            {
              ids: ids,
              status: _this.isPass

            },
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogCheckVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      popEdit(row) {
        this.dialogEditVisible = true;
        this.editData = row;

      },
      editSubmit() {
        let _this = this;

        this.$request1
          .post(
            '/commission/edit',
            _this.editData,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogEditVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      // 改变险种
      changeCategory(categoryId) {
        let _this = this;
        console.log("categoryId===>", categoryId);
        this.kinds = _this.categoryMap[categoryId]
        _this.kindId = "";
      },
      exportAll(type) {
        let _this = this;
        // if (this.multipleSelection.length == 0) {
        //   this.$message.error('请勾选要导出的订单');
        //   return;
        // }

        // console.log(orderIds, batchIds);
        // return;


        var url = tmsSpringUrl + '/commission/export';

        // 导出所有
        if(type==2){
          // url = tmsSpringUrl + '/commission/query';    

          if (this.conditions.orderIdText) {
            this.conditions.orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
            
        }
        this.conditions.export = 1



          this.$request1({
          url: '/commission/query',
          method: 'post',
          data: this.conditions,
          responseType: 'blob'
        }).then(res => {
          this.conditions.export = 0
          
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `order_commission_salesman__${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          
        })

          return;
          
          
        }

        var form = document.createElement("form");
        form.method = "post";
        form.action = url;
        form.target = "_blank";
        document.body.appendChild(form);


        if (this.conditions.orderIdText) {
          let orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
          orderIds.forEach(a => {
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "orderIds[]";
            input.value = a;
            form.appendChild(input);
          })
        }

        let d = { 
          exportType: type,
          startDate: this.conditions.startDate,
          endDate: this.conditions.endDate,
          salesman: this.conditions.salesman,
          orgOwner: this.conditions.orgOwner,
          productId: this.conditions.productId,
          status: this.conditions.status,
          export: 1,
          zero: this.conditions.zero
        }
        Object.keys(d).forEach(key => {
          var input1 = document.createElement("input");
          input1.type = "hidden";
          input1.name = key;
          input1.value = d[key];
          form.appendChild(input1);
        })

        
		  var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);

        form.submit();

      },
      //根据批次id查询购买保险的订单号
      showInsuranceOrderIds(batchId) {
        this.batchInsuranceOrderIdsShow = true
        this.$request1
          .post(
            '/insurance/batch-insurance-order?batchId=' + batchId,
            {},
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          ).then(response => {
            if (response.data.success) {
              this.batchOrderIds = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      // 提交前校验
      checkData(data) {

        for (let i = 0; i < data.length; i++) {
          let d = data[i];
          if (!d.fromArea) {
            this.$message.error('请补充起运港');
            return false;
          }
          if (!d.toArea) {
            this.$message.error('请补充目的港');
            return false;
          }
          if (!d.ladingNumber) {
            this.$message.error('请补充柜号/提单号');
            return false;
          }
          if (!d.transportNumber) {
            this.$message.error('请补充运单号');
            return false;
          }
          if (!d.airLandNumber) {
            this.$message.error('请补充航班/班列号');
            return false;
          }
          if (!d.fromTime) {
            this.$message.error('请补充起运时间');
            return false;
          }
          if (!d.currency) {
            this.$message.error('请补充币种');
            return false;
          }
          if (!d.totalValue) {
            this.$message.error('请补充申报总价值');
            return false;
          }
          if (!d.insuranceAddition) {
            this.$message.error('请补充加成比例');
            return false;
          }
          if (!d.fbaId) {
            this.$message.error('请补充fba id');
            return false;
          }
          if (!d.fbaAddress) {
            this.$message.error('请补充fba 地址');
            return false;
          }

        }
        return true;
      },
      //多选按钮
      handleSelectionChange(val) {
        console.log(">>>>>>val=", val);
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.currentPage = 1;
        this.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.query();
      },
      dateFormat(date, fmt) {
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
          "H+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds() //毫秒
        };
        var week = {
          "0": "/u65e5",
          "1": "/u4e00",
          "2": "/u4e8c",
          "3": "/u4e09",
          "4": "/u56db",
          "5": "/u4e94",
          "6": "/u516d"
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        if (/(E+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
              ? RegExp.$1.length > 2
                ? "/u661f/u671f"
                : "/u5468"
              : "") + week[date.getDay() + ""]
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    }
  };
</script>

<style>
  .el-message-box__message p {
    margin: 0;
    line-height: 24px;
    white-space: pre-wrap !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/commission.vue